import { isObject } from '@components/config/helpers'
import ParseHtml from '@components/Custom/ParseHtml'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Image from 'next/image'

const getPxNumber = (value) => {
    if (isObject(value)) return null

    const match = String(value || '').match(/^(\d+)px$/)

    if (!match) return null

    const num = Number(match[1])

    return Number.isFinite(num) ? num : null
}

const normaliseCssSize = (value, fallback = '100%') => {
    if (!value) return fallback

    if (value === 'auto') return fallback

    return value
}

const getImageBoxSize = (value, fallback = '100%') => {
    if (isObject(value)) return value

    return normaliseCssSize(value, fallback)
}

export default function RenderSections({
    spacing,
    sections = {},
    gridProps = { xs: 12, lg: 6 },
}) {
    return (
        <Grid container spacing={spacing}>
            {Object.entries(sections).map(([sectionKey, section]) => {
                const imageLayout = section?.layout?.image || {}

                const width = getPxNumber(section.width)
                const height = getPxNumber(section.height)

                const hasFixedPixelDimensions = width !== null && height !== null

                const size =
                    section?.layout?.item?.size ||
                    section?.layout?.size ||
                    gridProps

                const imageBoxWidth =
                    imageLayout.width ||
                    getImageBoxSize(section.width, '100%')

                const imageBoxHeight =
                    imageLayout.height ||
                    getImageBoxSize(section.height, '300px')

                return (
                    <Grid key={sectionKey} size={size}>
                        {section.title && <ParseHtml html={section.title} />}

                        {section.content && <ParseHtml html={section.content} />}

                        {section.image &&
                            (hasFixedPixelDimensions ? (
                                <Box
                                    className="mt-4"
                                    sx={{
                                        width: {
                                            xs: '100%',
                                            lg: `${width}px`,
                                        },
                                    }}
                                >
                                    <Image
                                        src={section.image}
                                        alt={section.image_alt || ''}
                                        width={width}
                                        height={height}
                                        sizes="100vw"
                                        style={{
                                            width: '100%',
                                            height: 'auto',
                                            objectFit: 'contain',
                                        }}
                                    />
                                </Box>
                            ) : (
                                <Box
                                    className="position-relative mt-4"
                                    sx={{
                                        width: imageBoxWidth,
                                        height: imageBoxHeight,
                                    }}
                                >
                                    <Image
                                        src={section.image}
                                        alt={section.image_alt || ''}
                                        fill
                                        sizes="100vw"
                                        style={{
                                            objectFit:
                                                imageLayout.objectFit ||
                                                'cover',
                                            ...imageLayout.style,
                                        }}
                                    />
                                </Box>
                            ))}
                    </Grid>
                )
            })}
        </Grid>
    )
}